import { axiosPrivate } from "api/axiosCore";

const basic_url = "api/oologs/";

export const serviceGetAuthHistory = async (token, query, roleFunctions, page, limit = 10) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    roleFunctions = roleFunctions || [];
    var response = null;
    let queryData = "";
    if(query.email){
        queryData = query.email ? "&f=oolog.email&q=" + query.email : "";
    }
    response = await axiosPrivate.get(basic_url + `?order=DESC&fo=oolog.createdAt&take=${limit}&page=${page || 1}` + queryData);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};